/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2017
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../UndoRedoButton'
], function(BaseClass) {

	var Button = BaseClass.extend({
		onPress: function(context){
			var api = context.glassContext.appController.getCurrentContentView().getDashboardApi();
			if (api) {
				api.redo();
			}
		},

		canEnable: function(controller) {
			return controller.canRedo();
		}
	});
	return Button;
});
